export const SEO = {
  LOGIN: {
    TITLE: "greytHR-Pro Login",
    DESCRIPTION:
      "Login with you company email address with passwords to start greytHR Pro account.",
    KEYWORDS: "greytHR-Pro Login, greytHR-Pro, Manage-PSP companies",
  },
  DASHBOARD: {
    TITLE: "greytHR-Pro Dashboard",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Dashboard, greytHR-Pro,",
  },
  TEAMS: {
    TITLE: "greytHR-Pro Teams",
    DESCRIPTION:
      "View and manage your organization’s team members.Team Insights Monitor key metrics, optimize workloads, and boost team effectiveness",
    KEYWORDS: "greytHR-Pro Teams, greytHR-Pro, Teams",
  },
  CLIENTS: {
    TITLE: "greytHR-Pro Clients",
    DESCRIPTION:
      "Manage and directly login into your clients’ greytHR accounts",
    KEYWORDS: "greytHR-Pro Clients, greytHR-Pro, Clients",
  },
  CLIENT_REPORTEES: {
    TITLE: "greytHR-Pro Clients",
    DESCRIPTION:
      "Manage and directly login into your clients’ greytHR accounts",
    KEYWORDS: "greytHR-Pro Clients, greytHR-Pro, Clients",
  },
  ROLES: {
    TITLE: "greytHR-Pro Roles",
    DESCRIPTION:
      "Effortlessly synchronize greytHR roles across multiple greytHR accounts",
    KEYWORDS: "greytHR-Pro Roles, greytHR-Pro, Roles",
  },
  HELPDESK: {
    TITLE: "greytHR-Pro Help Desk",
    DESCRIPTION: "View and track clients’ employee ticket information",
    KEYWORDS: "greytHR-Pro Help Desk, greytHR-Pro, Help Desk ",
  },
  "NEWS-AND-ALERTS": {
    TITLE: "greytHR-Pro News and Alerts",
    DESCRIPTION:
      "Access news and alerts regarding greytHR products and compliance updates",
    KEYWORDS: "greytHR-Pro News and Alerts, greytHR-Pro, News and Alerts",
  },
  "CLIENT-DETAILS": {
    TITLE: "greytHR-Pro Client Details",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Clients Details, greytHR-Pro, Client Details",
  },
  "TEAM-DETAILS": {
    TITLE: "greytHR-Pro Team Details",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Team Details, greytHR-Pro, Team Details",
  },
  "ROLE-HISTORY": {
    TITLE: "greytHR-Pro Role History",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Role History, greytHR-Pro, Role History",
  },
  SETTINGS: {
    TITLE: "greytHR-Pro Settings",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Settings, greytHR-Pro, Settings",
  },
  "YOUR-TICKETS": {
    TITLE: "greytHR-Pro greytHR Pro Tickets",
    DESCRIPTION: "",
    KEYWORDS:
      "greytHR-Pro greytHR Pro Tickets, greytHR-Pro, greytHR Pro Tickets",
  },
  PROFILE: {
    TITLE: "greytHR-Pro Profile",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Profile, greytHR-Pro, Profile",
  },
  "PRIVACY-POLICY": {
    TITLE: "greytHR-Pro Privacy Policy",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Privacy Policy, greytHR-Pro, Privacy Policy",
  },
  "TERMS-OF-USE": {
    TITLE: "greytHR-Pro Terms of Use",
    DESCRIPTION: "",
    KEYWORDS: "greytHR-Pro Terms of Use, greytHR-Pro, Terms of Usey",
  },
  "CREATE-PASSWORD": {
    TITLE: "greytHR-Pro Create Password",
    DESCRIPTION: "",
    KEYWORDS: " ",
  },
  "FORGOT-PASSWORD": {
    TITLE: "greytHR-Pro Forgot Password",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "VERIFY-SSO": {
    TITLE: "greytHR-Pro Verify-SSO",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "RESET-PASSWORD": {
    TITLE: "greytHR-Pro Reset-Password",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "TEAMS-create": {
    TITLE: "greytHR-Pro Create Team memeber",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "TEAMS-update": {
    TITLE: "greytHR-Pro Update Team memeber",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "SLA-Management": {
    TITLE: "greytHR-Pro SLA Management Template List",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "SLA-Management-create": {
    TITLE: "greytHR-Pro SLA Management Create Template",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "Invoice-Hub-Bulk": {
    TITLE: "greytHR-Pro Invoices Bulk Management",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  "Invoice-Hub-Client": {
    TITLE: "greytHR-Pro Invoices Client Management",
    DESCRIPTION: "",
    KEYWORDS: "",
  },
  PAYROLL_OVERVIEW: {
    TITLE: "greytHR-Pro Simplify Payroll with Unified View",
    DESCRIPTION:
      "The FBP Overview on gtPRO consolidates key data from all greytHR client accounts into a single dashboard, allowing payroll processors to track released plans, pending submissions, and payroll statuses efficiently, without logging into individual accounts. This centralized view enhances efficiency and simplifies FBP management across multiple clients.",
    KEYWORDS: "Simplify Payroll with Unified View",
  },
  POI: {
    TITLE: "greytHR-Pro POI Overview ",
    DESCRIPTION:
      "Simplify end-of-year investment proof collection with our upcoming feature. Track the status of POI forms across all clients in one view—no more switching accounts. Easily monitor released forms, pending reviews, payroll-ready submissions, and more, ensuring a smooth and efficient tax adjustment process.",
    KEYWORDS: "Centralize Your POI Process with Ease",
  },
  FPB: {
    TITLE: "greytHR-Pro FBP Management Simplified with gtPRO",
    DESCRIPTION:
      "The FBP Overview on gtPRO consolidates key data from all greytHR client accounts into a single dashboard, allowing payroll processors to track released plans, pending submissions, and payroll statuses efficiently, without logging into individual accounts. This centralized view enhances efficiency and simplifies FBP management across multiple clients.",
    KEYWORDS: "FBP Management Simplified with gtPRO",
  },
  IT: {
    TITLE: "greytHR-Pro IT Declaration Management Simplified",
    DESCRIPTION:
      "The IT Declaration Management feature in gtPRO centralizes key data from multiple greytHR accounts, allowing payroll processors to efficiently track the statuses of employee declarations—locked, released, pending review, and considered—without logging into each client account. This streamlines the monitoring process and enhances overall efficiency..",
    KEYWORDS: "IT Declaration Management Simplified",
  },
  TASK: {
    TITLE: "greytHR-Pro Tasks overview",
    DESCRIPTION:
      "The Task Management feature in gtPRO centralizes pending tasks from multiple greytHR accounts, allowing payroll processors to monitor workflows—like Leave, Reimbursement, and Helpdesk—from a single dashboard. This streamlines access and saves time, eliminating the need to log into each client account separately.",
    KEYWORDS: "Optimize Payroll with Tasks overview",
  },
  GREYTHR_SUPPORT: {
    TITLE: "greytHR-Pro GreytHR Support Tickets From Freshdesk",
    DESCRIPTION: "Display GreytHR Tickets.",
    KEYWORDS: "GreytHR Tickets From Freshdesk",
  },
  PAN_STATUS: {
    TITLE: "greytHR-Pro PAN Statuses",
    DESCRIPTION: "View consolidated PAN Statuses of your clients",
    KEYWORDS: "GreytHR-Pro  PAN Statuses",
  },
  FBP_OVERVIEW: {
    TITLE: "greytHR-Pro FBP Overview",
    DESCRIPTION: `A Flexible Benefits Plan (FBP) allows employees to customize their salary structure to maximize tax benefits. Under this plan,
organizations allocate a specific amount to each employee, which can be used to select from a range of benefits based on their
personal needs and preferences. This flexibility helps employees lower their taxable income by choosing benefits that are either taxexempt or carry lower tax implications`,
    KEYWORDS: "GreytHR Pro FBP",

  }
}
